import styled from 'styled-components';

const Wrapper = styled.div`
	.holla-wallet-wrapper {
		.cw-description {
			padding-top: 4px;
			padding-bottom: 24px;
		}
	}
	.holla-wallet-form {
		width: 250px;
		.btn-area {
			margin-top: 12px;
			display: flex;
		}
	}

	.mainnet {
		margin-top: 22px;
		padding-bottom: 15px;
		.mainnet-switch {
			margin: 0 12px;
		}
	}

	.ant-radio-wrapper.ant-radio-wrapper-checked {
		border-color: #00f !important;
	}

	.ant-form-item-children p {
		line-height: 1.2;
		margin-bottom: 4px;
	}

	.switch-label {
		position: relative;
		margin: 0 5px;
		span {
			position: relative;
			z-index: 1;
		}
		&.on {
			font-weight: bold;
		}
		i {
			font-style: normal;
			display: inline-block;
			width: 290px;
			z-index: 0;
			padding: 12px 12px 12px 30px;
			font-size: 0.7rem;
			line-height: 1.2;
			position: absolute;
			left: 35px;
			top: -22px;
			display: block;
			margin: 0;
			border: 1px solid #e9e9e9;
			border-radius: 5px;
			font-weight: normal;
		}
	}

	.holla-wallet-confirm {
		.holla-wallet-confirm-desc {
			margin-bottom: 12px;
		}
		.holla-wallet-confirm-recover-phrase {
			margin: 22px 0;
			width: 330px;
			padding: 22px 12px;
			border: 1px solid #393939;
			position: relative;
			display: flex;
			.title {
				position: absolute;
				left: 15px;
				top: -12px;
				background-color: #fff;
			}
			> div {
				flex: 1;
				> div {
					line-height: 28px;
				}
			}
		}
		.holla-wallet-confirm-warning {
			display: flex;
			align-items: center;
			margin-bottom: 22px;
			img {
				width: 42px;
			}
			.holla-wallet-confirm-warning-text {
				margin-left: 12px;
			}
		}
		.holla-wallet-confirm-check {
			margin: 24px 0;
		}
	}
	.holla-wallet-confirm-button {
		width: 400px;
		display: flex;
	}
	.holla-set-pin {
		width: 500px;
		.description {
			margin-bottom: 12px;
		}
	}
	.holla-type-wallet-list {
		width: 660px;
		display: flex;
		margin-top: 22px;
		margin-bottom: 22px;
		align-items: center;
		justify-content: space-around;
		.holla-type-wallet-card {
			min-width: 300px;
			max-width: 300px;
			border: 1px solid #29292C;
			text-align: center;
			cursor: pointer;
			img {
				width: 100px;
			}
			&:hover {
				background-color: #e9e9ff;
				border: 1px solid #fff;
			}
		}
	}
	@media (max-width: 1200px) {
		.holla-wallet-form {
			width: 100%;
		}
		.switch-label {
			i {
				position: static;
				width: 100%;
				padding: 12px;
				margin: 0;
			}
		}

		.holla-wallet-confirm {
			.holla-wallet-confirm-button {
				width: 100%;
			}
		}
		.holla-type-wallet-list {
			width: 100%;
			flex-direction: column;
			.holla-type-wallet-card {
				min-width: none;
				max-width: none;
				flex: 1;
			}
		}
	}
`;

export const TestWrapper = styled.div`
	.option-area {
		margin-bottom: 12px;
		button {
			margin-right: 8px;
		}
	}
	.spin-wrapper {
		position: absolute;
		z-index: 200;
		left: 0;
		top: 0;
		width: 100%;
		height: 100%;
		background-color: rgba(200, 200, 200, 0.5);
		> * {
			position: absolute;
			left: 45%;
			top: 45%;
		}
	}
`;

export const RestoreWrapper = styled.div`
	.flex-wrap {
		display: flex;
		> div {
			flex: 1px;
		}
		> div:last-child {
			margin-left: 8px;
		}
	}
	.seed-word {
		p {
			margin-bottom: 0;
		}
		margin-bottom: 8px;
	}
	@media (max-width: 1200px) {
		width: 100%;
	}
`;

export default Wrapper;
